const routes = [
  {
    path: 'index',
    name: 'index',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/modules/shared/views/manual/CentralPage.vue')
  },
  {
    path: 'loan-pro-help',
    name: 'loan-pro-help',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/modules/shared/views/manual/LoanPro.vue')
  },
  {
    path: 'ifrs9-help',
    name: 'ifrs9-help',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/modules/shared/views/manual/Ifrs9.vue')
  },
  {
    path: 'settings',
    name: 'settings-manual',
    meta: {
      requiresAuth: false
    },
    component: () => import('@/modules/shared/views/manual/Settings.vue')
  }
];

export default routes;
